import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/icon-sub-add.png'


const _withScopeId = n => (_pushScopeId("data-v-390fbda7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "condition-box" }
const _hoisted_2 = { class: "operator" }
const _hoisted_3 = { class: "unit" }
const _hoisted_4 = { class: "operator" }
const _hoisted_5 = { class: "unit" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_8 = { class: "ws_drawer_footer" }

import { ref, watch, computed } from 'vue'
import { isEmpty } from 'lodash'
import {
  queryLocusAoiAll,
  alarmStrategyAdd,
  alarmStrategyUpdate,
  alarmStrategyDetail,
  queryDeviceInfoByGatewayDeviceId,
  queryProductThingModelMetadata,
  queryDevicethingList,
  queryDevicethingDeviceList,
  queryDevicethingAttrList,
} from '@/api'
import {
  CODE_ENUM,
  WARNING_TYPE_ENUM,
  TACTICS_TIME_TYPE_ENUM,
  PRODUCT_TYPE,
  OPERATOR_TYPE,
  ALARM_SATISFY_TYPE,
  ALARM_LEVEL_TYPE,
  ALARM_MODE_TYPE,
  ALARM_TIME_TYPE,
} from '@/common'
import { ElMessage, genFileId } from 'element-plus'
import i18n from '@/i18n'
import { useWarningStore } from '@/stores/warning'
import { useDeviceStore } from '@/stores/device'


export default /*#__PURE__*/_defineComponent({
  __name: 'form-drawer-2',
  props: ['visible', 'data'],
  emits: ['update:visible', 'on-success'],
  setup(__props, { emit: $emit }) {

const props = __props;

const t = i18n.global.t




const warningStore = useWarningStore()

const deviceStore = useDeviceStore()

warningStore.getTriggerType()
warningStore.getSensorType()

watch(
  () => props.visible,
  () => {
    if (props.visible) {
      queryTemplateList()
      queryDetial()
    }
  },
  {
    deep: true,
  }
)

const queryDetial = async () => {
  if (!props.data.id) {
    return
  }
  const res: any = await alarmStrategyDetail({
    alarmStrategyId: props.data?.id,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    const mo = res?.data || {}
    const { name, sensorInfo, alarmLevelCode, thingModelId, deviceInfos } = mo

    const { conditionCode } = sensorInfo || {}
    const deviceIds = (deviceInfos || []).map((_: any) => _.deviceId)
    const result = {
      thingModelId,
      deviceIds,
      name,
      conditionCode,
      alarmLevelCode,
      sensors: delSensorsData(sensorInfo?.sensors || []),
    }
    form.value = result

    onThingModelChange(thingModelId, true)
  }
}

// fuck sb  将thresholdStart和thresholdEnd转为number
const delSensorsData = (sensors: any) => {
  if (sensors.length) {
    return sensors.map((item: any) => {
      return {
        ...item,
        thresholdStart: item.thresholdStart
          ? Number(item.thresholdStart)
          : undefined,
        thresholdEnd: item.thresholdEnd ? Number(item.thresholdEnd) : undefined,
      }
    })
  }
  return [
    {
      operatorTypeCode: '',
      sensorAttrCode: '',
      thresholdStart: undefined,
      thresholdEnd: undefined,
      conditionDuringUnitCode: ALARM_TIME_TYPE.SECOND,
      conditionDuring: undefined,
    },
  ]
}

const showIncrease = computed(() => {
  return form.value.sensors?.length <= 30
})

const operatorList: any = [
  {
    value: OPERATOR_TYPE.GREATER,
    label: t('W_TACTICS.operator1'),
    unit: '>',
  },
  {
    value: OPERATOR_TYPE.LESS,
    label: t('W_TACTICS.operator2'),
    unit: '<',
  },
  {
    value: OPERATOR_TYPE.EQUAL,
    label: t('W_TACTICS.operator3'),
    unit: '=',
  },
  {
    value: OPERATOR_TYPE.GREATER_EQUAL,
    label: t('W_TACTICS.operator4'),
    unit: '≥',
  },
  {
    value: OPERATOR_TYPE.LESS_EQUAL,
    label: t('W_TACTICS.operator5'),
    unit: '≤',
  },
  {
    value: OPERATOR_TYPE.GREATER_EQUAL_AND_LESS_EQUAL,
    label: t('W_TACTICS.operator6'),
    unit: '≥',
    unit2: '≤',
  },
]

// 等级告警
const levelOps = [
  {
    label: t('W_TACTICS.main'),
    value: ALARM_LEVEL_TYPE.ALARM_MAIN,
  },
  {
    label: t('W_TACTICS.minor'),
    value: ALARM_LEVEL_TYPE.ALARM_MINOR,
  },
  {
    label: t('W_TACTICS.urgency'),
    value: ALARM_LEVEL_TYPE.ALARM_URGENCY,
  },
  {
    label: t('W_TACTICS.warn'),
    value: ALARM_LEVEL_TYPE.ALARM_WARN,
  },
  // {
  //   label: t('W_TACTICS.clean'),
  //   value: ALARM_LEVEL_TYPE.ALARM_CLEAN,
  // },
]

const modeOps = [
  {
    label: t('W_TACTICS.simple'),
    value: ALARM_MODE_TYPE.SIMPLE,
  },
  {
    label: t('W_TACTICS.duringTime'),
    value: ALARM_MODE_TYPE.DURING_TIME,
  },
  {
    label: t('W_TACTICS.duringNum'),
    value: ALARM_MODE_TYPE.DURING_NUM,
  },
]

const timeOps = [
  {
    label: t('W_TACTICS.time1'),
    value: ALARM_TIME_TYPE.SECOND,
  },
  {
    label: t('W_TACTICS.time2'),
    value: ALARM_TIME_TYPE.MINUTE,
  },
  {
    label: t('W_TACTICS.time3'),
    value: ALARM_TIME_TYPE.HOUR,
  },
  {
    label: t('W_TACTICS.time4'),
    value: ALARM_TIME_TYPE.DAY,
  },
]

// 是否展示第二个条件
const showSecondThreshold = (operatorTypeCode: string) => {
  return operatorTypeCode === OPERATOR_TYPE.GREATER_EQUAL_AND_LESS_EQUAL
}

// 获取运算符
const getOperator = (operatorTypeCode: string, key: string) => {
  return (
    operatorList.filter((item: any) => {
      return item.value === operatorTypeCode
    })?.[0]?.[key] || ''
  )
}

const formRef = ref()

const form: any = ref({
  name: '',
  thingModelId: '',
  deviceIds: [],
  conditionCode: '',
  sensors: [
    {
      operatorTypeCode: '',
      sensorAttrCode: '',
      thresholdStart: undefined,
      thresholdEnd: undefined,
      conditionDuringUnitCode: ALARM_TIME_TYPE.SECOND,
      conditionDuring: undefined,
    },
  ],
  alarmLevelCode: '',
})

const rules: any = {
  name: [{ required: true, message: '请输入' }],
  thingModelId: [{ required: true, message: '请选择' }],
  deviceIds: [{ required: true, message: '请选择', type: 'array' }],
  conditionCode: [{ required: true, message: '请选择' }],
  alarmLevelCode: [{ required: true, message: '请选择' }],
}

const checkAll = ref(false)
const indeterminate = ref(false)

const handleCheckAll = (val: any) => {
  indeterminate.value = false
  if (val) {
    const list = getDeviceList(form.value.thingModelId || []).map(
      (_: any) => _.deviceId
    )
    form.value.deviceIds = list
  } else {
    form.value.deviceIds = []
  }
}
watch(
  () => form.value.deviceIds,
  (val) => {
    const list = getDeviceList(form.value.thingModelId || [])
    if (val.length === 0) {
      checkAll.value = false
      indeterminate.value = false
    } else if (val.length === list.length) {
      checkAll.value = true
      indeterminate.value = false
    } else {
      indeterminate.value = true
    }
  },
  {
    deep: true,
  }
)

const getUnit = (thingModelId: string, sensorAttrCode: string) => {
  const unitList = attrMap.value[thingModelId] || []
  return (
    unitList.filter((item: any) => {
      return item.code === sensorAttrCode
    })?.[0]?.unit || ''
  )
}

const submit = () => {
  formRef.value.validate((valid: boolean) => {
    if (valid) {
      handleAPI()
    }
  })
}

const loading = ref(false)
const handleAPI = async () => {
  loading.value = true

  const { conditionCode, sensors, ...p } = form.value
  // 傻逼
  const alarmStrategyAddSensorParam = {
    conditionCode,
    sensors,
  }
  const fn = props.data.id ? alarmStrategyUpdate : alarmStrategyAdd
  const res: any = await fn({
    ...p,
    alarmStrategyAddSensorParam,
    triggerId: props.data?.id,
    triggerTypeCode: WARNING_TYPE_ENUM.SENSOR,
  }).finally(() => {
    loading.value = false
  })
  if (res.code === CODE_ENUM.SUCCESS) {
    ElMessage.success(res?.msg)
    $emit('on-success')
    handleClose()
  }
}

const handleClose = () => {
  $emit('update:visible', false)
  formRef.value?.resetFields?.()
  form.value = {
    name: '',
    thingModelId: '',
    deviceIds: [],
    conditionCode: '',
    sensors: [
      {
        operatorTypeCode: '',
        sensorAttrCode: '',
        thresholdStart: undefined,
        thresholdEnd: undefined,
        conditionDuringUnitCode: ALARM_TIME_TYPE.SECOND,
        conditionDuring: undefined,
      },
    ],
    alarmLevelCode: '',
  }
}

const increase = (key: string) => {
  form.value[key].push({
    operatorTypeCode: '',
    sensorAttrCode: '',
    thresholdStart: undefined,
    thresholdEnd: undefined,
    conditionDuringUnitCode: ALARM_TIME_TYPE.SECOND,
    conditionDuring: undefined,
  })
}

const reduce = (key: string, i: number) => {
  form.value[key] = form.value[key].filter(
    (item: any, index: number) => index !== i
  )
}

const templateList: any = ref([])
const queryTemplateList = async () => {
  const res: any = await queryDevicethingList()
  if (res?.code === CODE_ENUM.SUCCESS) {
    templateList.value = res.data || []
  }
}

// 物模型下
const onThingModelChange = async (thingModelId: any, isNoReset?: boolean) => {
  if (!isNoReset) {
    form.value.deviceIds = []
  }
  queryDevieList(thingModelId)
  queryAttrList(thingModelId)
}

const deviceMap: any = ref({})
const getDeviceList = (thingModelId: any) => {
  return deviceMap.value[thingModelId] || []
}
const queryDevieList = async (thingModelId: any) => {
  if (deviceMap.value[thingModelId]?.length) {
    return
  }
  const res: any = await queryDevicethingDeviceList({
    curPage: 1,
    pageSize: 99999,
    thingModelId,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    deviceMap.value[thingModelId] = res.data?.records || []
  }
}

const attrMap: any = ref({})
const getAttrList = (thingModelId: any) => {
  return attrMap.value[thingModelId] || []
}
const queryAttrList = async (thingModelId: any) => {
  if (attrMap.value[thingModelId]?.length) {
    return
  }
  const res: any = await queryDevicethingAttrList({
    thingModelId,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    attrMap.value[thingModelId] = res.data || []
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    "model-value": props.visible,
    "destroy-on-close": "",
    title: props.data.id ? '编辑告警策略' : '新建告警策略',
    size: "1100px",
    "before-close": handleClose,
    "label-position": "left"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_8, [
        _createVNode(_component_el_button, {
          onClick: submit,
          loading: loading.value,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 确定 ")
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_el_button, {
          onClick: handleClose,
          plain: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        model: form.value,
        rules: rules,
        class: "form ws_common_form",
        "label-width": 80
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('W_TACTICS.labelNameForm'),
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: form.value.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.name) = $event)),
                modelModifiers: { trim: true },
                maxlength: "50",
                placeholder: _ctx.$t('W_TACTICS.labelNamePla'),
                style: {"width":"355px"}
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_el_form_item, {
                label: '模板名称',
                prop: "thingModelId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    onChange: onThingModelChange,
                    modelValue: form.value.thingModelId,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.thingModelId) = $event)),
                    style: {"width":"345px"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(templateList.value, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.modelName,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('W_TACTICS.deviceName'),
                prop: "deviceIds"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: form.value.deviceIds,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.deviceIds) = $event)),
                    class: "ws_select_form",
                    style: {"width":"345px"},
                    multiple: ""
                  }, {
                    header: _withCtx(() => [
                      _createVNode(_component_el_checkbox, {
                        modelValue: checkAll.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((checkAll).value = $event)),
                        indeterminate: indeterminate.value,
                        onChange: handleCheckAll
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 全选 ")
                        ]),
                        _: 1
                      }, 8, ["modelValue", "indeterminate"])
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getDeviceList(form.value.thingModelId), (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.deviceId,
                          label: item.deviceName,
                          value: item.deviceId
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('W_TACTICS.condition'),
                prop: "conditionCode"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: form.value.conditionCode,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.conditionCode) = $event)),
                    class: "ws_select_form",
                    style: {"width":"345px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        value: _unref(ALARM_SATISFY_TYPE).SATISFY_ALL,
                        label: _ctx.$t('W_TACTICS.conditionAll')
                      }, null, 8, ["value", "label"]),
                      _createVNode(_component_el_option, {
                        value: _unref(ALARM_SATISFY_TYPE).SATISFY_ONE,
                        label: _ctx.$t('W_TACTICS.conditionOne')
                      }, null, 8, ["value", "label"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    class: "sensors-form-item",
                    prop: "sensors",
                    "label-width": 1,
                    rules: [
                {
                  required: true,
                  message: _ctx.$t('W_TACTICS.sensorsMsg'),
                  trigger: 'change',
                  type: 'array',
                },
              ]
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.sensors, (domain, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "bg",
                          key: index
                        }, [
                          _createVNode(_component_el_form_item, {
                            "label-width": "5",
                            prop: 'sensors.' + index + '.conditionDuringTypeCode',
                            rules: [
                    {
                      required: true,
                      message: _ctx.$t('W_TACTICS.selectMsg'),
                      trigger: 'change',
                    },
                  ]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: domain.conditionDuringTypeCode,
                                "onUpdate:modelValue": ($event: any) => ((domain.conditionDuringTypeCode) = $event),
                                class: "select_item",
                                placeholder: _ctx.$t('W_TACTICS.mode'),
                                clearable: ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(modeOps, (item) => {
                                    return _createVNode(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"])
                                  }), 64))
                                ]),
                                _: 2
                              }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"])
                            ]),
                            _: 2
                          }, 1032, ["prop", "rules"]),
                          _createVNode(_component_el_form_item, {
                            prop: 'sensors.' + index + '.deviceId',
                            "label-width": 1
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                "label-width": "5",
                                prop: 'sensors.' + index + '.sensorAttrCode',
                                rules: [
                      {
                        required: true,
                        message: _ctx.$t('W_TACTICS.selectMsg'),
                        trigger: 'change',
                      },
                    ]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: domain.sensorAttrCode,
                                    "onUpdate:modelValue": ($event: any) => ((domain.sensorAttrCode) = $event),
                                    class: "select_item",
                                    placeholder: _ctx.$t('W_TACTICS.varPla')
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getAttrList(form.value.thingModelId), (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.code,
                                          label: item.name,
                                          value: item.code
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"])
                                ]),
                                _: 2
                              }, 1032, ["prop", "rules"]),
                              _createVNode(_component_el_form_item, {
                                "label-width": "5",
                                prop: 'sensors.' + index + '.operatorTypeCode',
                                rules: [
                      {
                        required: true,
                        message: _ctx.$t('W_TACTICS.selectMsg'),
                        trigger: 'change',
                      },
                    ]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: domain.operatorTypeCode,
                                    "onUpdate:modelValue": ($event: any) => ((domain.operatorTypeCode) = $event),
                                    class: "select_item",
                                    placeholder: _ctx.$t('W_TACTICS.range')
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(operatorList, (item) => {
                                        return _createVNode(_component_el_option, {
                                          key: item.value,
                                          label: item.label,
                                          value: item.value
                                        }, null, 8, ["label", "value"])
                                      }), 64))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"])
                                ]),
                                _: 2
                              }, 1032, ["prop", "rules"]),
                              _createVNode(_component_el_form_item, {
                                "label-width": "5",
                                prop: 'sensors.' + index + '.thresholdStart',
                                class: "operation-form",
                                rules: [
                      {
                        required: true,
                        message: _ctx.$t('W_TACTICS.enterMsg'),
                        trigger: 'change',
                      },
                      {
                        message: _ctx.$t('W_TACTICS.enterMsg'),
                        trigger: 'change',
                        type: 'number',
                      },
                    ]
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_2, _toDisplayString(getOperator(domain.operatorTypeCode, 'unit')), 1),
                                  _createVNode(_component_el_input_number, {
                                    class: "select_value input-number",
                                    modelValue: domain.thresholdStart,
                                    "onUpdate:modelValue": ($event: any) => ((domain.thresholdStart) = $event),
                                    placeholder: _ctx.$t('W_TACTICS.thresholdPla'),
                                    precision: 2,
                                    controls: false
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]),
                                  _createElementVNode("span", _hoisted_3, _toDisplayString(getUnit(form.value.thingModelId, domain.sensorAttrCode)), 1)
                                ]),
                                _: 2
                              }, 1032, ["prop", "rules"]),
                              (showSecondThreshold(domain.operatorTypeCode))
                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                    key: 0,
                                    "label-width": "5",
                                    prop: 'sensors.' + index + '.thresholdEnd',
                                    class: "operation-form",
                                    rules: [
                      {
                        required: true,
                        message: _ctx.$t('W_TACTICS.enterMsg'),
                        trigger: 'change',
                      },
                      {
                        message: _ctx.$t('W_TACTICS.enterMsg'),
                        trigger: 'change',
                        type: 'number',
                      },
                    ]
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_4, _toDisplayString(getOperator(domain.operatorTypeCode, 'unit2')), 1),
                                      _createVNode(_component_el_input_number, {
                                        class: "select_value input-number",
                                        modelValue: domain.thresholdEnd,
                                        "onUpdate:modelValue": ($event: any) => ((domain.thresholdEnd) = $event),
                                        modelModifiers: { number: true },
                                        placeholder: _ctx.$t('W_TACTICS.thresholdPla'),
                                        precision: 2,
                                        controls: false
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]),
                                      _createElementVNode("span", _hoisted_5, _toDisplayString(getUnit(form.value.thingModelId, domain.sensorAttrCode)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["prop", "rules"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["prop"]),
                          (
                    domain.conditionDuringTypeCode ===
                    _unref(ALARM_MODE_TYPE).DURING_TIME
                  )
                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 0,
                                "label-width": "5",
                                prop: 'sensors.' + index + '.conditionDuring',
                                rules: [
                    {
                      required: true,
                      message: _ctx.$t('W_TACTICS.selectMsg'),
                      trigger: 'change',
                    },
                  ]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input_number, {
                                    placeholder: _ctx.$t('W_TACTICS.keepTime'),
                                    modelValue: domain.conditionDuring,
                                    "onUpdate:modelValue": ($event: any) => ((domain.conditionDuring) = $event),
                                    "controls-position": "right",
                                    precision: 0,
                                    min: 1,
                                    style: {"width":"120px"}
                                  }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1032, ["prop", "rules"]))
                            : _createCommentVNode("", true),
                          (
                    domain.conditionDuringTypeCode ===
                    _unref(ALARM_MODE_TYPE).DURING_TIME
                  )
                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 1,
                                "label-width": "5",
                                prop: 'sensors.' + index + '.conditionDuringUnitCode'
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: domain.conditionDuringUnitCode,
                                    "onUpdate:modelValue": ($event: any) => ((domain.conditionDuringUnitCode) = $event),
                                    class: "select-unit"
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(timeOps, (item) => {
                                        return _createVNode(_component_el_option, {
                                          key: item.value,
                                          label: item.label,
                                          value: item.value
                                        }, null, 8, ["label", "value"])
                                      }), 64))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1032, ["prop"]))
                            : _createCommentVNode("", true),
                          (
                    domain.conditionDuringTypeCode ===
                    _unref(ALARM_MODE_TYPE).DURING_NUM
                  )
                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 2,
                                "label-width": "5",
                                prop: 'sensors.' + index + '.conditionDuring',
                                rules: [
                    {
                      required: true,
                      message: _ctx.$t('W_TACTICS.selectMsg'),
                      trigger: 'change',
                    },
                  ]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input_number, {
                                    placeholder: _ctx.$t('W_TACTICS.count'),
                                    modelValue: domain.conditionDuring,
                                    "onUpdate:modelValue": ($event: any) => ((domain.conditionDuring) = $event),
                                    "controls-position": "right",
                                    precision: 0,
                                    min: 1,
                                    style: {"width":"90px"}
                                  }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1032, ["prop", "rules"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            onClick: ($event: any) => (reduce('sensors', index)),
                            class: "icon-delete"
                          }, null, 8, _hoisted_6)
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["rules"])
                ]),
                _: 1
              }),
              (_unref(showIncrease))
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    class: "ws_mt5",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (increase('sensors'))),
                    type: "text"
                  }, {
                    icon: _withCtx(() => [
                      _hoisted_7
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('W_TACTICS.add')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('W_TACTICS.alarmLevel'),
            prop: "alarmLevelCode"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: form.value.alarmLevelCode,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.alarmLevelCode) = $event)),
                class: "ws_select",
                clearable: "",
                style: {"width":"355px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(levelOps, (item) => {
                    return _createVNode(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["model-value", "title"]))
}
}

})